module.exports = __webpack_public_path__ + "static/media/avatarPlaceholder.bcee821d.svg";